var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._b({ref:"inputAmount",attrs:{"prepend-icon":_vm.icon,"type":"number","rules":_vm.rules},on:{"click:prepend":_vm.toggleAmountType},model:{value:(_vm.amountValue),callback:function ($$v) {_vm.amountValue=$$v},expression:"amountValue"}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }